export enum AgentStatus {
  Active = "Active",
  Offline = "Offline",
  Disabled = "Disabled",
  Failure = "Failure",
}
